$.fn.randomContent = function() {
  let self = this
  self.selected_element = Math.floor(Math.random() * self.find('.grid__item').length);
  self.find('.grid__item').eq(self.selected_element).css('display', 'block');

  return function() {
    return self
  }()
};
